import { TdsIcon } from '@scania/tegel-react'
import styled from 'styled-components'

export interface MobileMenuHeaderButtonProps {
  onClick: () => void
}

const HeaderButton = styled.button.attrs({
  className: 'tds-nav__mob-menu-btn'
})``

export function MobileMenuHeaderButton({
  onClick
}: MobileMenuHeaderButtonProps) {
  return (
    <HeaderButton onClick={onClick}>
      <TdsIcon name='burger' size='20px' />
    </HeaderButton>
  )
}
